import { useFieldContext } from '~/util/hooks/useFormContext';
import { useDisableFormContext } from '../DisableContext';
import {
    FieldWithErrorProps,
    FieldLabelWithError,
} from './FieldLabelWithError';
import { useState } from 'react';
import { getTimeZones } from '@vvo/tzdb';
import { TimezoneTags } from '~/partials/Tags';
import { TimezoneSelector } from '~/components/ItemSelector';

export function TimezoneField({
    forceDisabled,
    ...labelProps
}: {
    forceDisabled?: boolean;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const [timezoneSelectorOpen, setTimezoneSelectorOpen] = useState(false);
    const disabled = useDisableFormContext() || forceDisabled;

    const selected = field.state.value
        ? 
              getTimeZones({ includeUtc: true }).find((tz) => tz.name === field.state.value) ??
                  getTimeZones({ includeUtc: true }).find((tz) => tz.name === 'Etc/UTC')!
          
        : undefined;

    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <TimezoneTags
                items={!selected ? [] : [selected]}
                editable={!disabled}
                onEdit={() => setTimezoneSelectorOpen(true)}
            />
            <TimezoneSelector
                open={timezoneSelectorOpen}
                onOpenChange={setTimezoneSelectorOpen}
                initial={selected}
                onSave={(item) => {
                    field.handleChange(item ? item.name : null);
                    setTimezoneSelectorOpen(false);
                }}
                single={true}
            />
        </FieldLabelWithError>
    );
}
